import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import $1Ofoe$intlmessageformat from "intl-messageformat";

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {
    get: v,
    set: s,
    enumerable: true,
    configurable: true
  });
}

var $70eee6030fd7c1a1$exports = {};
$parcel$export($70eee6030fd7c1a1$exports, "MessageDictionary", function () {
  return $70eee6030fd7c1a1$export$64839e615120df17;
});

var $70eee6030fd7c1a1$export$64839e615120df17 = /*#__PURE__*/function () {
  function $70eee6030fd7c1a1$export$64839e615120df17(messages) {
    var defaultLocale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en-US';

    _classCallCheck(this, $70eee6030fd7c1a1$export$64839e615120df17);

    // Clone messages so we don't modify the original object.
    this.messages = _objectSpread({}, messages);
    this.defaultLocale = defaultLocale;
  }

  _createClass($70eee6030fd7c1a1$export$64839e615120df17, [{
    key: "getStringForLocale",
    value: function getStringForLocale(key, locale) {
      var strings = this.messages[locale];

      if (!strings) {
        strings = $70eee6030fd7c1a1$var$getStringsForLocale(locale, this.messages, this.defaultLocale);
        this.messages[locale] = strings;
      }

      var string = strings[key];
      if (!string) throw new Error("Could not find intl message ".concat(key, " in ").concat(locale, " locale"));
      return string;
    }
  }]);

  return $70eee6030fd7c1a1$export$64839e615120df17;
}();

function $70eee6030fd7c1a1$var$getStringsForLocale(locale, strings) {
  var defaultLocale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'en-US';
  // If there is an exact match, use it.
  if (strings[locale]) return strings[locale]; // Attempt to find the closest match by language.
  // For example, if the locale is fr-CA (French Canadian), but there is only
  // an fr-FR (France) set of strings, use that.
  // This could be replaced with Intl.LocaleMatcher once it is supported.
  // https://github.com/tc39/proposal-intl-localematcher

  var language = $70eee6030fd7c1a1$var$getLanguage(locale);

  for (var key in strings) {
    if (key.startsWith(language + '-')) return strings[key];
  } // Nothing close, use english.


  return strings[defaultLocale];
}

function $70eee6030fd7c1a1$var$getLanguage(locale) {
  // @ts-ignore
  if (Intl.Locale) // @ts-ignore
    return new Intl.Locale(locale).language;
  return locale.split('-')[0];
}

var $a96338b8d4eb3cb0$exports = {};
$parcel$export($a96338b8d4eb3cb0$exports, "MessageFormatter", function () {
  return $a96338b8d4eb3cb0$export$526ebc05ff964723;
});

var $a96338b8d4eb3cb0$export$526ebc05ff964723 = /*#__PURE__*/function () {
  function $a96338b8d4eb3cb0$export$526ebc05ff964723(locale, messages) {
    _classCallCheck(this, $a96338b8d4eb3cb0$export$526ebc05ff964723);

    this.locale = locale;
    this.messages = messages;
    this.cache = {};
  }

  _createClass($a96338b8d4eb3cb0$export$526ebc05ff964723, [{
    key: "format",
    value: function format(key, variables) {
      var message = this.cache[key];

      if (!message) {
        var msg = this.messages.getStringForLocale(key, this.locale);
        if (!msg) throw new Error("Could not find intl message ".concat(key, " in ").concat(this.locale, " locale"));
        message = new $1Ofoe$intlmessageformat(msg, this.locale);
        this.cache[key] = message;
      }

      var varCopy;
      if (variables) varCopy = Object.keys(variables).reduce(function (acc, key) {
        acc[key] = variables[key] == null ? false : variables[key];
        return acc;
      }, {});
      return message.format(varCopy);
    }
  }]);

  return $a96338b8d4eb3cb0$export$526ebc05ff964723;
}();

export { $70eee6030fd7c1a1$export$64839e615120df17 as MessageDictionary, $a96338b8d4eb3cb0$export$526ebc05ff964723 as MessageFormatter };